// Query
import qs from 'query-string';

const route = (query = null) =>
  `/login/perform${!!query ? `?${qs.stringify(query)}` : ''}`;

export default route;
